<template>
  <LearnDialog />
</template>

<script>
import LearnDialog from '@components/learn_dialog';

export default {
  name: 'Learn',
  components: {
    LearnDialog,
  },
};
</script>
